import styled from 'styled-components'
import { darkColors } from '../../theme/colors'
import { Box } from '../Box'

export const StyledFooter = styled(Box)<{ isBlackThemePage: boolean }>`
  background: ${({ isBlackThemePage }) =>
    isBlackThemePage
      ? 'linear-gradient(180deg, #161616 100%, rgba(16, 16, 16, 0) 100%)'
      : 'linear-gradient(180deg, #2D0059 0%, #101010 100%)'};
`

export const StyledText = styled.span`
  color: ${darkColors.text};
`
